export const CalculateLogementquantite = (checkIn, checkOut) => {
    const checkInDate = new Date(checkIn);
    const checkOutDate = new Date(checkOut);
    let diffDays=0;

    if (!isNaN(checkInDate.getTime()) && !isNaN(checkOutDate.getTime())) {
       diffDays = Math.ceil((checkOutDate - checkInDate) / (1000 * 60 * 60 * 24));
       return diffDays;
    } else{
        return 0;
    }
};